import { render, staticRenderFns } from "./ResearchReportNumber.vue?vue&type=template&id=21ef47c8&scoped=true"
import script from "./ResearchReportNumber.vue?vue&type=script&lang=js"
export * from "./ResearchReportNumber.vue?vue&type=script&lang=js"
import style0 from "./ResearchReportNumber.vue?vue&type=style&index=0&id=21ef47c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ef47c8",
  null
  
)

export default component.exports